enum LOCAL_STORAGE_KEYS {
    BET_LIST_FILTER = 'betListFilter',
}

export default LOCAL_STORAGE_KEYS;
